import { render, staticRenderFns } from "./CustomerRegistrationDialog.vue?vue&type=template&id=6d456e83&scoped=true&"
import script from "./CustomerRegistrationDialog.vue?vue&type=script&lang=js&"
export * from "./CustomerRegistrationDialog.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRegistrationDialog.vue?vue&type=style&index=0&id=6d456e83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d456e83",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBarNavIcon,VBtn,VCard,VDialog,VIcon,VSpacer,VToolbar,VToolbarTitle})
